<template>
  <div class="flex justify-center items-center">
    <div class="w-1/2 flex h-screen bg-blue justify-center items-center">
      <h1 class="text-3xl font-semibold text-blue-lightest"> Doctor Dashboard </h1>
    </div>
    <div class="w-1/2 flex flex-col h-screen justify-center items-center">
      <div class="w-2/3 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
        <label class="block text-grey-darker text-base font-semibold mb-2">
          Set New Password
        </label>
        <input v-model="newPassword1" class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" id="newPassword" minlength="8" type="password" placeholder="New Password">
        <input v-model="newPassword2" class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight focus:outline-none focus:shadow-outline" type="password" minlength="8" placeholder="Re Enter Password"> 
        <p v-if="error && setPasswordError" class="text-red text-xs italic">{{setPasswordError}}</p>
        <div class="flex items-center justify-between">
          <button @click="cancelReset" type="button" class="bg-blue hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
            Cancel
          </button>
          <button @click="setPassword" type="button" class="bg-blue self-center hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
            Next
            <i v-if="isLoading" class="ml-2 fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
Vue.use(VueToast)
export default {
  data () {
    return {
      isLoading: false,
      error: false,
      setPasswordError: null,
      newPassword1: null,
      newPassword2: null
    }
  },
  methods: {
    setPassword: function () {
      event.preventDefault()
      if (this.newPassword1 && this.newPassword2 && this.newPassword1 === this.newPassword2) {
        if (this.newPassword1.length < 8) {
          this.error = true
          this.setPasswordError = 'Password is too short (minimum is 8 characters)'
        } else {
          var credentials = {
            reset_password_token: this.$route.params.token,
            password: this.newPassword1
          }
          this.isLoading = true
          this.$http.post(window.API_URL + 'doctors/reset_password', credentials).then(response => {
            if (response.status === 200) {
              this.isLoading = false
              window.location.href = '/login'
            }
          }).catch(function (error) {
            this.isLoading = false
            console.log(error)
            if (error.status === 401) {
              this.$toast.open({
                message: error.body.message,
                type: 'error',
                position: 'top',
                queue: false
              })
            } else if (error.status === 403) {
              this.$toast.open({
                message: error.body.message,
                type: 'warning',
                position: 'top',
                queue: false
              })
            }
          })
        }
      } else if (!this.newPassword1 || !this.newPassword2) {
        this.error = true
        this.setPasswordError = "Passwords can't be empty"
      } else {
        this.error = true
        this.setPasswordError = "Both the passwords don't match"
      }
    },
    cancelReset: function () {
      this.$router.replace('/login')
    }
  }
}

</script>

<style lang="scss" scoped>
$danger: hsl(348, 100%, 61%);
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue